import React, {useEffect, useState} from 'react';
import {IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import messages from "res/messages/farsi";
import Comment from "./Comment";
import IconTitleButton from "components/buttons/IconTitleButton";
import {useHistory} from "react-router-dom";


export default function Comments(props) {

    const [commentList, setCommentList] = useState([])
    const history = useHistory();
    useEffect(() => {
        if (props.comments) {
            setCommentList(props.comments);
        }
    })

    function view() {

        return <div className="center marginSmall"
                    style={{
                        marginTop: "1em",
                    }}>
            {commentList && commentList.length > 0 ?
                <div className="" onClick={() => {
                    if (props.showDate === false) {
                        props.onNavigate(history, '/commentList?v=' + props.product_id + '&p=1')
                    }
                }}>
                    <div className="largeTextBold"
                         style={{
                             width: "100%",
                             textAlign: 'justify',
                             display: 'flex',
                             justifyContent: 'space-between',
                             borderBottom: ' 1px solid #e0e0e0'
                         }}>
                        <p style={{margin: '0'}}> {messages.customerComments}</p>
                        {props.seeAll ? <p style={{margin: '0'}}>
                            <IconTitleButton
                                textcolor="var(--blue_5)"
                                onClick={() => {
                                    if (props.product_id) {
                                        props.onNavigate(history, '/commentList?v=' + props.product_id + '&p=1')
                                    }
                                }}
                                title={messages.seeAll}/></p> : ''}

                    </div>
                    <div className="titleProductList HScrollInMobile marginTopSmall " style={{paddingBottom: '1rem'}}>
                        <div className="horizontalScreen" style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            gap: IsLP_MP_SP_T() ? '1rem' : ''
                        }}>
                            {commentList.map((comment, index) => {
                                return <div key={index} className="titleProduct"
                                            style={{height: '100%', width: '97%'}}>
                                    <Comment {...props} comment={comment}/>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                :
                <div></div>
            }

        </div>

    }

    function sliderView() {

        return <div className="center marginSmall"
                    style={{
                        marginTop: "1em",
                        height: IsLP_MP_SP() ? 440 : props.hasImage && props.hasImage === 1 ? 340 : 230
                    }}>
            {commentList && commentList.length > 0 ?
                <div className="" onClick={() => {
                    if (props.showDate === false) {
                        props.onNavigate(history, '/commentList?v=' + props.product_id + '&p=1')
                    }
                }}>
                    <div className="largeTextBold"
                         style={{
                             width: "100%",
                             textAlign: 'justify',
                             display: 'flex',
                             justifyContent: 'space-between',
                             borderBottom: ' 1px solid #e0e0e0'
                         }}>
                        <p style={{margin: '0'}}> {messages.customerComments}</p>
                        {props.seeAll ? <p style={{margin: '0'}}>
                            <IconTitleButton
                                textcolor="var(--blue_5)"
                                onClick={() => {
                                    if (props.product_id) {
                                        props.onNavigate(history, '/commentList?v=' + props.product_id + '&p=1')
                                    }
                                }}
                                title={messages.seeAll}/></p> : ''}
                    </div>
                    <div className="titleProductList HScrollInMobile">
                        <div className="horizontalScreen">
                            {commentList.map((comment, index) => {
                                return <div key={index} className="titleProduct"
                                            style={{height: IsLP_MP_SP() ? 440 : props.hasImage && props.hasImage === 1 ? 245 : 165}}>
                                    <Comment {...props} comment={comment}/>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                :
                <div></div>
            }

        </div>

    }

    return (<>
        {props.full && props.full === true ? view() : sliderView()}
    </>)
}